const { debounce: baoDebounce } = window.BAO.Utils
class SectionHotspots extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.classes = {
      active: 'prd-Hotspot-active',
    }
  }

  connectedCallback () {
    super.connectedCallback()
    this.calculateMobileOffsets()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener(
      'resize',
      baoDebounce(this.calculateMobileOffsets.bind(this), 200),
    )

    this.els?.form?.elements.forEach((form) => {
      form.addEventListener('submit', () => {
        this.hideAllPopups()
      })
    })

    this.els?.submit?.elements.forEach((submit) => {
      submit.addEventListener('click', () => {
        this.hideAllPopups()
      })
    })

    this.els?.toggle?.elements.forEach((toggle) => {
      const parentHotspot = toggle.closest(
        '[data-section-hotspots-el="hotspot"]',
      )

      if (!parentHotspot) return

      toggle.addEventListener('click', () => {
        this.hideOtherPopups(parentHotspot)
        parentHotspot.classList.toggle(this.classes.active)
      })
    })

    this.els?.close?.elements.forEach((close) => {
      const parentHotspot = close.closest(
        '[data-section-hotspots-el="hotspot"]',
      )

      if (!parentHotspot) return

      close.addEventListener('click', () => {
        parentHotspot.classList.remove(this.classes.active)
      })
    })
  }

  hideAllPopups () {
    this.els?.hotspot?.elements.forEach((hotspot) => {
      hotspot.classList.remove(this.classes.active)
    })
  }

  hideOtherPopups (target) {
    const externalHotspots = this.externalEls.hotspot?.elements
      ? this.externalEls.hotspot.elements
      : []
    const hotspots = this.els.hotspot?.elements
      ? this.els.hotspot.elements
      : [];

    [...hotspots, ...externalHotspots].forEach((hotspot) => {
      if (hotspot !== target) hotspot.classList.remove(this.classes.active)
    })
  }

  calculateMobileOffsets () {
    if (window.innerWidth >= 768) return

    const containerRect =
      this.externalEls.container.element.getBoundingClientRect()
    const containerCenter = containerRect.width / 2

    this.els?.popup?.elements.forEach((popup) => {
      const hotspot = popup.closest('[data-section-hotspots-el="hotspot"]')
      if (!hotspot) return

      const hotspotRect = hotspot.getBoundingClientRect()
      const hotspotCenter =
        hotspotRect.left - containerRect.left + hotspotRect.width / 2

      const offset = containerCenter - hotspotCenter

      popup.style.setProperty('--popup-mobile-offset', `${offset}px`)
    })
  }
}

if (!customElements.get('section-hotspots')) {
  customElements.define('section-hotspots', SectionHotspots)
}
